import axios from "axios";

function setJwt(jwt) {
  if (jwt) {
    axios.defaults.headers.common["Authorization"] = jwt[0];
  } else {
    axios.defaults.headers.common["Authorization"] = null;
  }
}

export default {
  get: axios.get,
  post: axios.post,
  delete: axios.delete,
  setJwt,
};
